var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoDataServices = function SvgNoDataServices(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 40C39.4477 40 38.3953 39.8133 37.575 39.4398L26.0125 34.1672C25.4836 33.9266 24.25 33.2227 24.25 31.8938C24.25 30.5648 25.4836 29.8625 26.0141 29.6188L37.6766 24.3008C39.2836 23.5664 41.7086 23.5664 43.3164 24.3008L54.9859 29.6188C55.5164 29.8602 56.75 30.5641 56.75 31.8938C56.75 33.2234 55.5164 33.925 54.9859 34.168L43.4234 39.4398C42.6047 39.8133 41.5523 40 40.5 40Z",
    fill: "#999999",
    stroke: "#999999",
    strokeWidth: 0.0625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9812 37.7195L53.8023 37.1875L50.7734 38.5734L43.4297 41.9328C42.6094 42.3078 41.5547 42.4945 40.5047 42.4945C39.4547 42.4945 38.4008 42.3078 37.5813 41.9328L30.232 38.5734L27.2023 37.1875L26.0133 37.7219C25.4836 37.9633 24.25 38.6719 24.25 40C24.25 41.3281 25.4836 42.0375 26.0125 42.2789L37.575 47.5625C38.3906 47.9375 39.4445 48.125 40.5 48.125C41.5555 48.125 42.6047 47.9375 43.425 47.5633L54.9773 42.2813C55.5094 42.0398 56.75 41.3352 56.75 40C56.75 38.6648 55.518 37.9633 54.9812 37.7195Z",
    fill: "#999999",
    stroke: "#999999",
    strokeWidth: 0.0625
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9812 45.8437L53.8023 45.3125L50.7734 46.6977L43.4297 50.0531C42.6094 50.4266 41.5547 50.6141 40.5047 50.6141C39.4547 50.6141 38.4008 50.4273 37.5813 50.0531L30.232 46.6937L27.2023 45.3125L26.0133 45.8469C25.4836 46.0883 24.25 46.7969 24.25 48.125C24.25 49.4531 25.4836 50.1617 26.0125 50.4023L37.575 55.6828C38.3906 56.0562 39.4484 56.25 40.5 56.25C41.5516 56.25 42.6 56.0563 43.4203 55.682L54.9766 50.4031C55.5094 50.1625 56.75 49.4578 56.75 48.125C56.75 46.7922 55.518 46.0883 54.9812 45.8437Z",
    fill: "#999999",
    stroke: "#999999",
    strokeWidth: 0.0625
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoDataServices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-data-services.d8a6b513.svg";
export { ForwardRef as ReactComponent };